import { marginTariff } from 'constants/tariffCodes';

const { MARGIN_TRAIN, MARGIN_TRAIN_ER, MARGIN_HOTEL } = marginTariff;

const codesToFilter = [MARGIN_TRAIN, MARGIN_TRAIN_ER, MARGIN_HOTEL];

export const hasExtras = (booking) =>
  booking.outbound.some((outbound) => outbound.extraProducts.length > 0) ||
  booking.inbound.some((inbound) => inbound.extraProducts.length > 0);

export const hasItem = (items) => items.some((item) => !item.cancelled);

export const hasTrainSegment = (booking) => Boolean(booking?.outbound?.length || booking?.inbound?.length);

export const filterMargins = (products) =>
  products.reduce((result, item = { extraProducts: [] }) => {
    const extraProducts = item.extraProducts.filter(({ tariffDetails = {} }) => !codesToFilter.includes(tariffDetails.tariffCode));

    return !item.cancelled && extraProducts.length
      ? result.concat({
          ...item,
          extraProducts
        })
      : result;
  }, []);

export const bookingContainOnlyUnRebookableItems = ({ outbound = [], inbound = [] }) => {
  const uncancelledOutbound = outbound.filter((o) => !o.cancelled);
  const uncancelledInbound = inbound.filter((i) => !i.cancelled);

  return (
    [
      uncancelledOutbound.filter((o) => o.products?.some((p) => !p.cancelled && p.canBeRebooked)),
      uncancelledInbound.filter((i) => i.products?.some((p) => !p.cancelled && p.canBeRebooked))
    ]?.flat()?.length === 0
  );
};
